import { Injectable } from '@angular/core'
import { Faq } from '../models/faq.model';
import { Pages } from '../models/faq.model'

@Injectable()
export class FaqService {
  lang = 'th'



  getFaqs(lang: string, page: Pages): Faq[] {
    this.lang = lang
    switch (page) {
      case Pages.Home:
        return this.homePage()
      case Pages.FunctionBusiness:
        return this.businessFunctionPage()
      case Pages.FunctionAccounting:
        return this.accontingFunctionPage()
      case Pages.Pricing:
        return this.pricingPage()
      case Pages.AccountingfirmBusinessOwner:
        return this.businessOwnerPage()
      case Pages.AccountingfirmAccountant:
        return this.accountantPage()
      case Pages.Seminars:
        return this.seminarPage()
      case Pages.Tutorials:
        return this.totorialsPage()
      case Pages.MigrateNewFlowAccount:
        return this.migratPage()
      case Pages.MigrateNewFlowAccount:
        return this.migratPage()
      case Pages.FunctionBillingNoteAndInvoiceFAQ:
        return this.billingNoteInvoicePage()
      case Pages.TaxInvoiceFAQ:
        return this.TaxInvoicePage()
      case Pages.FlowPay:
        return this.FlowPayPage()
    }
    return this.homePage()
  }

  // FunctionBillingNoteAndInvoice

  private homePage() {
    const FAQ1 = new Faq()
    FAQ1.heading =
      this.lang === 'th'
        ? 'โปรแกรมบัญชี ออนไลน์ FlowAccount เหมาะกับธุรกิจแบบไหน'
        : 'Was FlowAccount designed for my business?'
    FAQ1.shortDescription =
      this.lang === 'th'
        ? 'เหมาะกับฟรีแลนซ์ เจ้าของธุรกิจขนาดเล็ก SMEs หรือธุรกิจที่ต้องการเครื่องมือที่ช่วยออกเอกสารธุรกิจออนไลน์ ใช้งานได้ทั้งคอมพิวเตอร์ ไอแพด หรือมือถือ ช่วยให้ทำงานร่วมกับนักบัญชีสะดวกในระบบเดียวกัน'
        : "FlowAccount is a software accounting Thailand that designed for SMEs, small business owners, freelance consultants, and businesses that need an online suite of business solutions. FlowAccount was created for computers, tablets and smartphones. It's an efficient and easier way to manage your business even if you have HR and accounting staff a world away."
    FAQ1.link = ''
    FAQ1.head_class = ''
    FAQ1.detail_class = 'homepage-faq1'

    // ============================================================================================================

    const FAQ2 = new Faq()
    FAQ2.heading =
      this.lang === 'th'
        ? 'ออกเอกสาร ใบกำกับภาษี และ หนังสือรับรอง หัก ณ ที่จ่าย ได้ไหม'
        : 'Can FlowAccount help me issue tax invoices and withholding tax documents?'
    FAQ2.shortDescription =
      this.lang === 'th'
        ? 'สามารถใช้เว็บไซต์ และแอปพลิเคชั่น FlowAccount ออกใบกำกับภาษี และ หนังสือรับรองหัก ณ ที่จ่ายได้ ตามรูปแบบของสรรพากร '
        : "Yes. FlowAccount's tax invoices and withholding tax documents are also fully Revenue Department-compliant."
    FAQ2.link = ''
    FAQ2.head_class = ''
    FAQ2.detail_class = ''

    // ============================================================================================================

    const FAQ3 = new Faq()
    FAQ3.heading =
      this.lang === 'th' ? 'ข้อมูลที่อยู่ใน โปรแกรมบัญชี ออนไลน์ มีความปลอดภัยแค่ไหน' : 'Is my information safe?'
    FAQ3.shortDescription =
      this.lang === 'th'
        ? 'FlowAccount ใช้ระบบคลาวด์ Amazon Web Services ซึ่งมีความปลอดภัยสูง ได้มาตรฐานสากล มีการสำรองข้อมูล (BackUp) อย่างสม่ำเสมอ โดยผู้ใช้งานจะสามารถใช้งานได้ผ่านอีเมลและการเข้ารหัส นอกจากนี้ บริษัทของเราไม่มีนโยบายเปิดเผยข้อมูลของผู้ใช้งานให้กับบุคคลที่สาม จึงวางใจได้ในความปลอดภัยของข้อมูล <a class="faq-link" href="/privacy-statement">รายละเอียดเพิ่มเติม</a>'
        : 'Yes. FlowAccount utilizes a secure, world-class cloud storage system called Amazon Web Services, which is regularly backed up. Like any online app, users should choose a strong password and your own email address to login. FlowAccount does not share user information with third parties. <a class="faq-link" href="/privacy-statement">More Information</a>'
    FAQ3.link = ''
    FAQ3.head_class = ''
    FAQ3.detail_class = 'homepage-faq2'

    // ============================================================================================================

    const FAQ4 = new Faq()
    FAQ4.heading =
      this.lang === 'th' ? 'FlowAccount มีบริการอะไรเพิ่มเติมอีกบ้าง' : 'What other things does FlowAccount do?'
    FAQ4.shortDescription =
      this.lang === 'th'
        ? 'FlowAccount สามารถทำงานร่วมกับโปรแกรมเงินเดือน ออนไลน์ <a class="faq-link" href="https://flowpayroll.co/"  target="_blank" rel="nofollow noopener" >FlowPayroll</a> และโปรแกรมสแกนบิล และใบเสร็จ <a class="faq-link" href="https://autokey.io/"  target="_blank" rel="nofollow noopener" >AutoKey</a> ให้คุณมีระบบจัดการทั้งด้านบัญชี เงินเดือน และค่าใช้จ่าย อย่างมีประสิทธิภาพ นอกจากนี้เรายังมีทีมบริการที่ช่วยตอบคำถามระหว่างใช้งาน คอร์สออนไลน์สอนการใช้โปรแกรมฟรีทุกสัปดาห์ และช่วยคุณค้นหาสำนักงานบัญชีที่ถูกใจ'
        : 'FlowAccount is a cloud accounting program for business owners that suite solutions to starts with its financial accounting platform. you can use <a class="faq-link" href="https://flowpayroll.co/"  target="_blank" rel="nofollow noopener" >FlowPayroll</a>, which runs and pays employee payrolls; and <a class="faq-link" href="https://autokey.io/"  target="_blank" rel="nofollow noopener" >AutoKey</a>, which scans and records receipts. Our Customer Support team is available 7 days a week via telephone, Live Chat, and email. We also offer weekly online courses on FlowAccount, as well as a recommendation service for local accounting firms.'
    FAQ4.link = ''
    FAQ4.head_class = ''
    FAQ4.detail_class = ''

    // ============================================================================================================

    const FAQ5 = new Faq()
    FAQ5.heading =
      this.lang === 'th' ? 'ต้องติดตั้งโปรแกรมคอมพิวเตอร์หรือไม่' : 'Do I need to install any software on my computer?'
    FAQ5.shortDescription =
      this.lang === 'th'
      ? 'FlowAccount เป็น โปรแกรมสำเร็จรูปทางการบัญชี ทำงานผ่านเว็บไซต์และแอปพลิเคชั่นมือถือ FlowAccount ไม่จำเป็นต้องติดตั้งโปรแกรม สามารถล็อกอินในเว็บไซต์เพื่อเข้าใช้งานได้ทันที'
        : 'No. All FlowAccount apps are web-based. That means you can use FlowAccount anywhere you have a web-browser. We offer an app for smartphones: FlowAccount.'
    FAQ5.link = ''
    FAQ5.head_class = ''
    FAQ5.detail_class = 'homepage-faq5'

    // ============================================================================================================

    const FAQ6 = new Faq()
    FAQ6.heading =
      this.lang === 'th' ? 'หากต้องการสอบถามข้อมูลเพิ่มเติมจะติดต่อในช่องทางใดได้บ้าง' : 'How do I contact FlowAccount?'
    FAQ6.shortDescription =
      this.lang === 'th'
        ? 'ทางทีมงานพร้อมให้บริการผู้ใช้งานทุกท่าน โดยสามารถติดต่อเราได้ทางระบบ LiveChat อีเมล support@flowaccount.com และเบอร์โทรศัพท์ <a class="faq-link" href="tel:020268989">02-026-8989</a>'
        : 'Our Customer Support team is available 7 days a week, 9 am-6 pm (Bangkok), via LiveChat (bottom right hand side of the page), email (support@flowaccount.com) and by phone <a class="faq-link" href="tel:020268989">+662 0268989</a>.'
    FAQ6.link = ''
    FAQ6.head_class = ''
    FAQ6.detail_class = 'homepage-faq6'

    return [FAQ1, FAQ2, FAQ3, FAQ4, FAQ5, FAQ6]
  }

  private billingNoteInvoicePage() {
    const FAQ1 = new Faq()
    FAQ1.heading =
      this.lang === 'th'
        ? 'ใบวางบิล และ ใบแจ้งหนี้ ต่างกันอย่างไร'
        : 'What is the difference between a billing note and an invoice?'
    FAQ1.shortDescription =
      this.lang === 'th'
        ? '<b>ใบวางบิล</b> คือเอกสารใช้แจ้งยอดค่าชำระตามวันกำหนดวางบิล โดยจะสรุปยอดทั้งหมด หรือสรุปรายการสินค้าหรือบริการว่ามีอะไรบ้างให้กับลูกค้า<br><br><b>ใบแจ้งหนี้</b> คือเอกสารที่ใช้แจ้งจำนวนค่าสินค้าหรือบริการ ที่ออกให้ลูกค้าทุกครั้งหลังงานนั้นสำเร็จเรียบร้อยแล้ว ใบแจ้งหนี้จะระบุรายละเอียดสินค้า ค่าบริการ เป็นจำนวนเท่าไหร่ และลูกค้าจะต้องชำระเมื่อใด<br><br>ซึ่งในบางกรณีหรือบางธุรกิจอาจจะใช้เอกสารแค่ใบใดใบหนึ่ง หรือทั้งสองใบเลยก็ได้ ยกตัวอย่างเช่น ถ้ามีการขายของโดยรับชำระเงินแค่ครั้งเดียว ก็สามารถใช้ใบแจ้งหนี้แค่ใบเดียวได้เลย หรือกรณีธุรกิจขายส่ง ที่มีการส่งของหลายรอบ และออกใบแจ้งหนี้หลายใบ ก็สามารถออกใบวางบิลเพิ่มเพื่อสรุปยอดและเก็บเงินในครั้งเดียวได้'
        : 'A billing note is a document that reminds a customer to pay by a specific date. It shows the total sum as well as product/service details.<br><br> An invoice is a document that displays the total cost of products or services and is issued after the project is finished. It contains information on the products or services, including their specifications and costs, as well as the payment deadline.<br><br>In some cases a business can use either a billing note or an invoice, or both of the documents. For example, if you sell a product to customers only once, you can send them an invoice. If your wholesale business delivers goods to customers many times, you will need to make multiple invoices and billing notes to sum up pricing for your customers.'
    FAQ1.link = ''
    FAQ1.head_class = ''
    FAQ1.detail_class = 'homepage-faq1'

    // ============================================================================================================

    const FAQ2 = new Faq()
    FAQ2.heading =
      this.lang === 'th' ? 'ออกใบวางบิล และ ใบแจ้งหนี้ อย่างไร' : 'How to issue billing notes and invoices?'
    FAQ2.shortDescription =
      this.lang === 'th'
        ? '1. จัดเตรียมเอกสารในการวางบิล 1 ชุด (ประกอบด้วย ต้นฉบับ และสำเนา) หากมีใบเสนอราคา ใบแจ้งหนี้ ใบกำกับภาษี หรือใบสั่งซื้อ ก็ให้แนบไปพร้อมกับใบวางบิลเลยก็ได้<br><br>2. นำส่งเอกสารให้กับลูกค้าเซ็นยืนยันการรับใบวางบิล โดยลูกค้าจะเก็บเอกสารฉบับจริงและส่งเอกสารฉบับสำเนากลับมาให้ผู้วางบิลเก็บไว้เป็นหลักฐาน<br><br>3. หลังจากลูกค้าชำระเงินเรียบร้อยแล้ว ผู้ประกอบการออกใบกำกับภาษี หรือใบเสร็จรับเงิน มอบให้กับลูกค้าเพื่อเป็นหลักฐานในการรับเงิน'
        : '1. Prepare a set of billing notes (original and copy paper), as well as an enclosed quotation, invoice, tax invoice or purchase order, if necessary.<br><br>2. Submit the documentation to your customer and have them sign it to confirm the payments. The original paper is kept by the client, while your company collects the copy.<br><br>3. After the customer makes a payment, the company issues a tax invoice or receipt and sends it to the customer.'
    FAQ2.link = ''
    FAQ2.head_class = ''
    FAQ2.detail_class = ''

    // ============================================================================================================

    const FAQ3 = new Faq()
    FAQ3.heading =
      this.lang === 'th'
        ? 'ใบวางบิล ใบแจ้งหนี้ เหมาะกับธุรกิจประเภทไหน'
        : 'What types of businesses should use billing notes and invoices?'
    FAQ3.shortDescription =
      this.lang === 'th'
        ? 'ใบวางบิล ใบแจ้งหนี้ มักใช้กับธุรกิจสินค้า หรือบริการ ที่มีรอบของการชำระเงินแบบให้เครดิต  '
        : 'Billing notes and invoices are always used in businesses that have determined credit term payments for customers.'
    FAQ3.link = ''
    FAQ3.head_class = ''
    FAQ3.detail_class = 'homepage-faq2'

    // ============================================================================================================

    const FAQ4 = new Faq()
    FAQ4.heading =
      this.lang === 'th' ? 'ข้อมูลที่อยู่ใน โปรแกรมบัญชี ออนไลน์ มีความปลอดภัยแค่ไหน' : 'Is my information safe?'
    FAQ4.shortDescription =
      this.lang === 'th'
        ? 'FlowAccount ใช้ระบบคลาวด์ Amazon Web Services ซึ่งมีความปลอดภัยสูง ได้มาตรฐานสากล มีการสำรองข้อมูล (BackUp) อย่างสม่ำเสมอ โดยผู้ใช้งานจะสามารถใช้งานได้ผ่านอีเมลและการเข้ารหัส นอกจากนี้ บริษัทของเราไม่มีนโยบายเปิดเผยข้อมูลของผู้ใช้งานให้กับบุคคลที่สาม จึงวางใจได้ในความปลอดภัยของข้อมูล'
        : 'Yes. FlowAccount utilizes a secure, world-class cloud storage system called Amazon Web Services, which is regularly backed up. Like any online app, users should choose a strong password and your own email address to login. FlowAccount does not share user information with third parties.'
    FAQ4.link = ''
    FAQ4.head_class = ''
    FAQ4.detail_class = 'homepage-faq2'

    // ============================================================================================================

    return [FAQ1, FAQ2, FAQ3, FAQ4]
  }

  private TaxInvoicePage() {
    const FAQ4 = new Faq()
    FAQ4.heading = this.lang === 'th' ? 'E-Tax Invoice by E-mail คืออะไร' : 'What is E-Tax Invoice by E-mail?'
    FAQ4.shortDescription =
      this.lang === 'th'
        ? 'ฟังก์ชั่น e-Tax Invoice by Email บน FlowAccount ช่วยให้ผู้ประกอบการที่จดทะเบียนภาษีมูลค่าเพิ่มขนาดเล็ก สามารถจัดทำ จัดเก็บ และจัดส่งใบกำกับภาษีอิเล็กทรอนิกส์ ครบ จบในที่เดียว เพียงสร้างใบกำกับภาษี และกดส่งอีเมล e-Tax Invoice บน FlowAccount ให้กับคู่ค้าผ่าน สพธอ. (ETDA) เพื่อประทับรับรองเวลา (Timestamp) ช่วยประหยัดเวลาและค่าใช้จ่ายในการพิมพ์เอกสารและส่งไปรษณีย์ และประหยัดพื้นที่เก็บแฟ้มเอกสารในรูปแบบกระดาษ อ่าน FAQ <a href="https://flowaccount.com/faq/knowledge-base/e-tax-invoice-by-email/" target="_blank" rel="noopener noreferrer">วิธีการใช้ E-Tax Invoice by Email ในระบบ FlowAccount</a> ได้ที่นี่'
        : 'Sending electronics tax invoices by email on FlowAccount helps you issue, send and keep e-invoices in one place by simply creating an invoice and click "Send e-Tax Invoice by Email" to your client. Our system will send the e-invoices through ETDA system to get a timestamp. You no longer have to print, send and keep paper documents. '
    FAQ4.link = ''
    FAQ4.head_class = ''
    FAQ4.detail_class = 'homepage-faq2'

    // ============================================================================================================

    const FAQ3 = new Faq()
    FAQ3.heading =
      this.lang === 'th'
        ? 'ใบกำกับภาษี ต่างจาก ใบกำกับภาษีอย่างย่ออย่างไร'
        : 'What is the difference between a full tax invoice and an abbreviated tax invoice'
    FAQ3.shortDescription =
      this.lang === 'th'
        ? 'รายละเอียดในใบกำกับภาษีอย่างย่อ จะแสดงข้อมูลน้อยกว่าใบกำกับภาษีเต็มรูปคือ  <ul><li>ไม่ต้องแสดงที่อยู่ของผู้ขายสินค้าหรือบริการ</li> <li>ไม่ต้องแสดงชื่อและที่อยู่ของผู้ซื้อสินค้าหรือบริการ</li> <li>ชื่อ ชนิด หรือประเภทของสินค้าจะออกเป็นรหัสก็ได</li> <li>จำนวนภาษีมูลค่าเพิ่มให้รวมอยู่ในมูลค่าของสินค้าหรือบริการ โดยมีหมายเหตุว่า “ราคาได้รวมภาษีแล้ว” อย่างไรก็ตาม อาจจะแสดงราคาสินค้ากับจำนวนภาษีมูลค่าเพิ่มแยกออกจากกันก็สามารถทำได้</li> </ul>'
        : 'An abbreviated tax invoice has only some of the information normally stated on a full tax invoice.<ul><li>Your business address is not required.</li><li>Your customer\'s name and address are not required.</li> <li>Goods or services can be listed simply as codes (i.e., no description necessary.)</li><li>VAT must be included in the prices along with a statement, "Prices include VAT". (However, VAT amounts may be displayed separately from prices, if needed.)</ul>'
    FAQ3.link = ''
    FAQ3.head_class = ''
    FAQ3.detail_class = 'homepage-faq2'

    // ============================================================================================================

    const FAQ2 = new Faq()
    FAQ2.heading = this.lang === 'th' ? 'ใบกำกับภาษี ใครมีสิทธิออกได้บ้าง' : 'Who has the right to issue tax invoices?'
    FAQ2.shortDescription =
      this.lang === 'th'
        ? 'เป็นผู้ที่จด VAT เท่านั้น ผู้ที่ไม่ได้จด VAT ออกใบกำกับภาษีไม่ได้ ถ้าคุณคาดว่าจะมีรายได้ถึง 1.8 ล้านต่อปี จากการขายสินค้า หรือให้บริการ คุณต้องจดทะเบียนภาษีมูลค่าเพิ่มด้วย ไม่ว่าจะอยู่ในรูปแบบบริษัท หรือแบบบุคคลก็ตาม'
        : 'If you expect to earn at least 1.8 million baht annually, you are required by Thai law to register your business for VAT. This applies to freelancers/sole proprietorships as well as businesses. As a VAT-registered business, you have the right to issue tax invoices.'
    FAQ2.link = ''
    FAQ2.head_class = ''
    FAQ2.detail_class = 'homepage-faq3'

    // ============================================================================================================

    const FAQ1 = new Faq()
    FAQ1.heading =
      this.lang === 'th' ? 'ฟังก์ชั่นนี้เหมาะกับใคร' : "What businesses benefit from FlowAccount's VAT features?"
    FAQ1.shortDescription =
      this.lang === 'th'
        ? 'ธุรกิจที่จดทะเบียนภาษีมูลค่าเพิ่มแล้ว และมีการขายสินค้าหรือบริการทั้งหน้าร้านหรือร้านค้าออนไลน์ '
        : "FlowAccount's VAT feature helps all VAT-registered businesses simplify tax invoices, whether you are brick-and-mortar shop or an online store."
    FAQ1.link = ''
    FAQ1.head_class = ''
    FAQ1.detail_class = 'homepage-faq1'

    // ============================================================================================================

    return [FAQ1, FAQ2, FAQ3, FAQ4]
  }

  private pricingPage() {
    const FAQ1 = new Faq()
    FAQ1.heading =
      this.lang === 'th'
      ? 'ทดลองใช้งานฟรี 30 วัน สามารถใช้งานฟังก์ชันอะไรได้บ้าง'
      : 'ทดลองใช้งานฟรี 30 วัน สามารถใช้งานฟังก์ชันอะไรได้บ้าง'
    FAQ1.shortDescription =
      this.lang === 'th'
        ? 'สามารถใช้งานได้ "ครบทุกฟังก์ชัน" เทียบเท่าแพ็กเกจสูงสุด Pro Business อ่านรายละเอียดฟังก์ชันการใช้งานทั้งหมดเพิ่มเติมได้ ที่ตารางแพ็กเกจ และตารางฟังก์ชันในหน้านี้'
      : 'สามารถใช้งานได้ "ครบทุกฟังก์ชัน" เทียบเท่าแพ็กเกจสูงสุด Pro Business อ่านรายละเอียดฟังก์ชันการใช้งานทั้งหมดเพิ่มเติมได้ ที่ตารางแพ็กเกจ และตารางฟังก์ชันในหน้านี้'
    FAQ1.head_class = ''
    FAQ1.detail_class = ''

    // ============================================================================================================

    const FAQ2 = new Faq()
    FAQ2.heading =
      this.lang === 'th'
        ? 'หากหมดระยะเวลาทดลองใช้งานฟรี 30 วัน จะสามารถเข้าระบบได้หรือไม่'
      : 'หากหมดระยะเวลาทดลองใช้งานฟรี 30 วัน จะสามารถเข้าระบบได้หรือไม่'

    FAQ2.shortDescription =
      this.lang === 'th'
      ? 'เมื่อทดลองใช้งานฟรีครบทุกฟังก์ชั่นเทียบเท่าแพ็กเกจสูงสุด Pro Business จนครบ 30 วันแล้ว บัญชีการใช้งานของผู้สมัครเท่านั้นที่ยังสามารถเข้าระบบเพื่อสร้างเอกสารได้ และจำนวนผู้ใช้งานเพิ่มเติมท่านอื่นๆ จะเปลี่ยนสถานะเป็นสามารถเข้าไปดูได้เท่านั้น<br><br>ใช้งานได้เพียงการออกเอกสารในขั้นตอนการขาย<ul><li>ใบเสนอราคา(QT)</li><li> ใบเสร็จ(RE) </li><li> ใบแจ้งหนี้ / ใบวางบิล(BL) </li><li> ใบเสร็จ </li></ul>ไม่รองรับการสร้างเอกสารต่างๆ ดังนี้<ul> <li>ใบหัก ณ ที่จ่าย</li> <li>ใบวางบิลรวม</li><li> ใบเสร็จรวม </li><li>เอกสารแบ่งจ่าย มัดจำ</li><li>บันทึกค่าใช้จ่าย</li><li>ใบสำคัญจ่าย/ใบเตรียมจ่าย</li><li>ใบสั่งซื้อสินค้า(PO)</li><li>ใบรับสินค้า(RI)</li></ul><br>การนำเข้ายอดขายจากแพล็ตฟอร์ม Food Delivery และข้อมูลการซื้อ - ขายบนแพล็ตฟอร์ม E - Commerce จะหยุดการนำเข้าข้อมูลทันที โดยไม่สามารถเข้าไปแก้ไขข้อมมูลในเอกสารที่เคยสร้าง แต่ยังสามารถพรีวิวและสั่งพิมพ์ได้<br><br>เนื่องจาก FlowAccount ยังคงรักษาข้อมูลการสร้างเอกสาร และการบันทึกข้อมูลทางบัญชีทั้งหมดของผู้ใช้งานไว้ จนกว่าผู้ใช้งานจะสมัครใช้บริการในแพ็กเกจที่เหมาะกับธุรกิจ <br><br>ร้านค้าออนไลน์ที่เชื่อมต่อกับ Lazada หรือ Shopee ทันทีที่กดสมัครแพ็กเกจ Pro Business และกดเชื่อมต่ออีกครั้ง ระบบนำเข้ายอดขายผ่านการเชื่อมต่อ API ให้สามารถใช้งานได้ทันที '
      : 'เมื่อทดลองใช้งานฟรีครบทุกฟังก์ชั่นเทียบเท่าแพ็กเกจสูงสุด Pro Business จนครบ 30 วันแล้ว บัญชีการใช้งานของผู้สมัครเท่านั้นที่ยังสามารถเข้าระบบเพื่อสร้างเอกสารได้ และจำนวนผู้ใช้งานเพิ่มเติมท่านอื่นๆ จะเปลี่ยนสถานะเป็นสามารถเข้าไปดูได้เท่านั้น<br><br>ใช้งานได้เพียงการออกเอกสารในขั้นตอนการขาย<ul><li>ใบเสนอราคา(QT)</li><li> ใบเสร็จ(RE) </li><li> ใบแจ้งหนี้ / ใบวางบิล(BL) </li><li> ใบเสร็จ </li></ul>ไม่รองรับการสร้างเอกสารต่างๆ ดังนี้<ul> <li>ใบหัก ณ ที่จ่าย</li> <li>ใบวางบิลรวม</li><li> ใบเสร็จรวม </li><li>เอกสารแบ่งจ่าย มัดจำ</li><li>บันทึกค่าใช้จ่าย</li><li>ใบสำคัญจ่าย/ใบเตรียมจ่าย</li><li>ใบสั่งซื้อสินค้า(PO)</li><li>ใบรับสินค้า(RI)</li></ul><br>การนำเข้ายอดขายจากแพล็ตฟอร์ม Food Delivery และข้อมูลการซื้อ - ขายบนแพล็ตฟอร์ม E - Commerce จะหยุดการนำเข้าข้อมูลทันที โดยไม่สามารถเข้าไปแก้ไขข้อมมูลในเอกสารที่เคยสร้าง แต่ยังสามารถพรีวิวและสั่งพิมพ์ได้<br><br>เนื่องจาก FlowAccount ยังคงรักษาข้อมูลการสร้างเอกสาร และการบันทึกข้อมูลทางบัญชีทั้งหมดของผู้ใช้งานไว้ จนกว่าผู้ใช้งานจะสมัครใช้บริการในแพ็กเกจที่เหมาะกับธุรกิจ <br><br>ร้านค้าออนไลน์ที่เชื่อมต่อกับ Lazada หรือ Shopee ทันทีที่กดสมัครแพ็กเกจ Pro Business และกดเชื่อมต่ออีกครั้ง ระบบนำเข้ายอดขายผ่านการเชื่อมต่อ API ให้สามารถใช้งานได้ทันที '

    FAQ2.head_class = ''
    FAQ2.detail_class = 'pricingpage-faq2'

    // ============================================================================================================

    const FAQ3 = new Faq()
    FAQ3.heading =
      this.lang === 'th'
      ? 'สมัคร 1 แพ็กเกจ สามารถใช้งานได้กี่บริษัท'
      : 'สมัคร 1 แพ็กเกจ สามารถใช้งานได้กี่บริษัท'

    FAQ3.shortDescription =
      this.lang === 'th'
        ? 'สมัคร 1 แพ็กเกจ สามารถใช้งานได้ 1 บริษัท หากต้องการสร้างธุรกิจใหม่ ในอีเมลเดิม สามารถกดเพิ่มในระบบ และดำเนินการจ่ายเงินได้ด้วยตนเอง'
      : 'สมัคร 1 แพ็กเกจ สามารถใช้งานได้ 1 บริษัท หากต้องการสร้างธุรกิจใหม่ ในอีเมลเดิม สามารถกดเพิ่มในระบบ และดำเนินการจ่ายเงินได้ด้วยตนเอง'

    FAQ3.head_class = ''
    FAQ3.detail_class = 'pricingpage-faq3'

    // ============================================================================================================

    const FAQ4 = new Faq()
    FAQ4.heading =
      this.lang === 'th'
        ? 'สมัครแพ็กเกจแบบรายเดือน กับรายปี แตกต่างกันอย่างไร'
      : 'สมัครแพ็กเกจแบบรายเดือน กับรายปี แตกต่างกันอย่างไร'
    FAQ4.shortDescription =
      this.lang === 'th'
        ? 'ลูกค้าสามารถทดลอง Subscription เป็นรายเดือนเพื่อทดลองใช้งานก่อนได้ โดยการสมัครเป็นรายเดือนจะรับชำระค่าบริการผ่านบัตรเครดิตเท่านั้น<br><br> แต่หากสมัครเป็นรายปี จะช่วยประหยัดค่าบริการ 17% ต่อเดือน สามารถดำเนินการชำระได้ผ่าน QR Code หรือตัดจ่ายผ่านบัตรเครดิตด้วยตนเองได้เลย'
      : 'ลูกค้าสามารถทดลอง Subscription เป็นรายเดือนเพื่อทดลองใช้งานก่อนได้ โดยการสมัครเป็นรายเดือนจะรับชำระค่าบริการผ่านบัตรเครดิตเท่านั้น<br><br> แต่หากสมัครเป็นรายปี จะช่วยประหยัดค่าบริการ 17% ต่อเดือน สามารถดำเนินการชำระได้ผ่าน QR Code หรือตัดจ่ายผ่านบัตรเครดิตด้วยตนเองได้เลย'
    FAQ4.head_class = ''
    FAQ4.detail_class = 'pricingpage-faq4'

    // ============================================================================================================

    const FAQ5 = new Faq()
    FAQ5.heading =
      this.lang === 'th' ? 'สมัคร Standard แบบรายปีไปแล้ว อยากอัปเกรดแพ็กเกจสูงขึ้นระหว่างอายุการใช้งานได้หรือไม่' : 'สมัคร Standard แบบรายปีไปแล้ว อยากอัปเกรดแพ็กเกจสูงขึ้นระหว่างอายุการใช้งานได้หรือไม่'

    FAQ5.shortDescription =
      this.lang === 'th'
      ? 'ผู้ใช้งานสามารถอัปเกรดแพ็กเกจได้ตลอด เพื่อความเหมาะสมกับการบริหารธุรกิจ โดย FlowAccount จะไม่คิดค่าบริการแพ็กเกจใหม่ทั้งหมด  แต่จะเพิ่มค่าบริการเป็นส่วนต่างจากจำนวนอายุการใช้งานคงเหลือจากแพ็กเกจเดิม <br> <br>ผู้ใช้งานสามารถกดอัปเกรดแพ็กเกจระบบ FlowAccount ได้ด้วยตนเอง ตามวิธีการใน <a class="faq-link" href="https://www.youtube.com/watch?v=7NV5imSxzFEt" target="_blank"> วิดีโอคู่มือนี้ </a>' 
      : 'ผู้ใช้งานสามารถอัปเกรดแพ็กเกจได้ตลอด เพื่อความเหมาะสมกับการบริหารธุรกิจ โดย FlowAccount จะไม่คิดค่าบริการแพ็กเกจใหม่ทั้งหมด  แต่จะเพิ่มค่าบริการเป็นส่วนต่างจากจำนวนอายุการใช้งานคงเหลือจากแพ็กเกจเดิม <br> <br>ผู้ใช้งานสามารถกดอัปเกรดแพ็กเกจระบบ FlowAccount ได้ด้วยตนเอง ตามวิธีการใน <a class="faq-link" href="https://www.youtube.com/watch?v=7NV5imSxzFEt" target="_blank"> วิดีโอคู่มือนี้ </a>' 

    FAQ5.head_class = ''
    FAQ5.detail_class = 'pricingpage-faq5'

    // ============================================================================================================

    const FAQ6 = new Faq()
    FAQ6.heading =
      this.lang === 'th'
        ? 'แต่ละแพ็คเกจแตกต่างกันอย่างไร'
      : 'แต่ละแพ็คเกจแตกต่างกันอย่างไร'
    FAQ6.shortDescription =
      this.lang === 'th'
      ? '<strong>Free</strong> : เหมาะสำหรับฟรีแลนซ์<br><strong> Standard </strong>: เหมาะสำหรับเจ้าของกิจการที่ทำทุกอย่างได้ด้วยตนเอง และไม่มีพนักงาน<br><strong> Pro </strong>: เหมาะสำหรับเจ้าของกิจการที่มีพนักงาน และต้องการใช้เมนูสต็อกสินค้า<br> <strong> Pro Business </strong>: เหมาะสำหรับธุรกิจที่ต้องการใช้งานครบทุกฟังก์ชัน จ่ายเงินเดือนพนักงาน และเพื่อความสะดวกสบายในการเชื่อมต่อแพลตฟอร์มร้านค้าออนไลน์'
        : 'Yes, with some rare exceptions. We can help you upgrade to the new system seamlessly. <a class="faq-link" href="/en/upgrade-to-new-flowaccount " target="_blank">For more information</a>'
    FAQ6.head_class = ''
    FAQ6.detail_class = 'pricingpage-faq6'

    // ============================================================================================================

    const FAQ7 = new Faq()
    FAQ7.heading =
      this.lang === 'th'
        ? 'สมัครแพ็กเกจทำยังไง ต้องติดต่อใครบ้าง'
        : 'สมัครแพ็กเกจทำยังไง ต้องติดต่อใครบ้าง'
    FAQ7.shortDescription =
      this.lang === 'th'
      ? 'FlowAccount Customer Support  เราเปิดบริการเพื่อดูแลลูกค้าทุกท่าน ตลอด 365 วัน <br> คุณสามารถติดต่อได้ทาง Live Chat ที่มุมขวาล่างได้ตลอดเวลาทำการ <ul><li>จันทร์ - ศุกร์  08.00 น. - 22.00 น.</li> <li>เสาร์ - อาทิตย์	09.00 น. - 20.00 น.</li> </ul><br>หรือติดต่อทีมงานฝ่ายขายได้ที่ เบอร์ 02-026-8991'
      : 'FlowAccount Customer Support  เราเปิดบริการเพื่อดูแลลูกค้าทุกท่าน ตลอด 365 วัน <br> คุณสามารถติดต่อได้ทาง Live Chat ที่มุมขวาล่างได้ตลอดเวลาทำการ <ul><li>จันทร์ - ศุกร์  08.00 น. - 22.00 น.</li> <li>เสาร์ - อาทิตย์	09.00 น. - 20.00 น.</li> </ul><br>หรือติดต่อทีมงานฝ่ายขายได้ที่ เบอร์ 02-026-8991'
    FAQ7.head_class = ''
    FAQ7.detail_class = 'pricingpage-faq6'

    return [FAQ1, FAQ2, FAQ3, FAQ4, FAQ5, FAQ6, FAQ7]
  }

  private businessFunctionPage() {
    const FAQ1 = new Faq()
    const FAQ2 = new Faq()
    const FAQ3 = new Faq()
    return [FAQ1, FAQ2, FAQ3]
  }
  private accontingFunctionPage() {
    const FAQ1 = new Faq()
    const FAQ2 = new Faq()
    const FAQ3 = new Faq()
    return [FAQ1, FAQ2, FAQ3]
  }
  private businessOwnerPage() {
    const FAQ1 = new Faq()
    const FAQ2 = new Faq()
    const FAQ3 = new Faq()
    return [FAQ1, FAQ2, FAQ3]
  }
  private accountantPage() {
    const FAQ1 = new Faq()
    const FAQ2 = new Faq()
    const FAQ3 = new Faq()
    return [FAQ1, FAQ2, FAQ3]
  }
  private seminarPage() {
    const FAQ1 = new Faq()
    const FAQ2 = new Faq()
    const FAQ3 = new Faq()
    return [FAQ1, FAQ2, FAQ3]
  }
  private totorialsPage() {
    const FAQ1 = new Faq()
    const FAQ2 = new Faq()
    const FAQ3 = new Faq()
    return [FAQ1, FAQ2, FAQ3]
  }
  private migratPage() {
    const FAQ1 = new Faq()
    const FAQ2 = new Faq()
    const FAQ3 = new Faq()
    return [FAQ1, FAQ2, FAQ3]
  }

  private FlowPayPage() {
    const FAQ1 = new Faq()
    FAQ1.heading =  'ระบบรับชำระเงินออนไลน์ FlowPay คืออะไร '
    FAQ1.shortDescription =  'FlowPay คือระบบที่ FlowAccount พัฒนาขึ้นมาให้ทุกกิจการสามารถรับชำระเงินออนไลน์ พร้อมเก็บหลักฐานการโอน และลงบันทึกบัญชีให้อัตโนมัติ เปิดรับชำระเงินออนไลน์ได้หลายช่องทาง ทั้งระบบจ่ายเงินผ่าน QR Code, บริการรับชำระด้วยบัตรเครดิตออนไลน์ พร้อมบัตรเดบิต และ PromptPay  <br><br>ด้วยทางเลือก 2 รูปแบบ<br><br>1) ระบบสแกนจ่ายเงิน ผ่าน QR Code ที่ผู้ขายสร้างจากเลขบัญชีธนาคารแล้วบันทึกในระบบ แชร์เป็นลิงก์ส่งให้ผู้ซื้อสแกนจ่าย พร้อมแนบหลักฐานมาได้เลยทันที  <br> <br>2) บริการรับชำระด้วยบัตรเครดิตออนไลน์ พร้อมบัตรเดบิต หรือ PromptPay ด้วยการเชื่อมต่อระบบ FlowAccount เข้ากับช่องทางรับชำระมาตรฐานระดับสากลอย่าง Stripe หรือ Omise <br> <br>เหมาะกับธุรกิจ SMEs ทุกรูปแบบ ให้คุณทำธุรกิจได้คล่องตัวกว่า ง่ายตั้งแต่เปิดการขายจนถึงรับเงินออนไลน์ พร้อมทำบัญชีให้ครบ จบในระบบเดียว  <br><br>เริ่มใช้ได้ตั้งแต่แพ็กเกจ Standard เป็นต้นไป '
    FAQ1.link = ''
    FAQ1.head_class = ''
    FAQ1.detail_class = 'homepage-faq2'

    const FAQ2 = new Faq()
    FAQ2.heading =  'Payment Gateway ที่เชื่อมต่อกับโปรแกรมบัญชีออนไลน์ คืออะไร' 
    FAQ2.shortDescription =  'Payment Gateway เป็นระบบที่จะเข้ามาช่วยยืนยันการทำธุรกรรมการเงิน ให้มีความถูกต้อง ปลอดภัย สะดวก และรวดเร็วมากขึ้น ข้ามขีดจำกัดในการทำธุรกิจบนโลกออนไลน์ ให้คุณและลูกค้า ไม่ว่าจะอยู่ที่ไหนก็สามารถชำระเงินได้<br><br>FlowAccount ที่มุ่งมั่นจะเป็นให้คุณมากกว่าโปรแกรมบัญชีออนไลน์ จึงเปิดสะพานเชื่อมความเป็นไปได้ เพิ่มระบบการรับชำระเงินออนไลน์ ด้วย Payment Gateway เจ้าใหญ่ระดับสากลอย่าง Stripe และ Omise เพื่อให้คุณ สามารถแชร์ลิงก์เอกสาร ให้ลูกค้าชำระเงินตามช่องทางที่สะดวกได้เลย ทั้งระบบจ่ายเงินผ่าน QR Code, บริการรับชำระด้วยบัตรเครดิตออนไลน์ พร้อมทั้งบัตรเดบิต และทุกช่องทางที่ Payment Gateway ร่วมกับ FlowAccount เปิดให้คุณทำธุรกรรม พร้อมลงบันทึกบัญชีให้คุณอัตโนมัติในระบบ'
    FAQ2.link = ''
    FAQ2.head_class = ''
    FAQ2.detail_class = 'homepage-faq2'

    const FAQ3 = new Faq()
    FAQ3.heading =  'Stripe หรือ Omise  เหมาะกับธุรกิจประเภทไหน' 
    FAQ3.shortDescription = 'ไม่ว่าจะธุรกิจประเภทไหน ขนาดใหญ่หรือเล็ก ก็สามารถใช้งาน Stripe หรือ Omise ได้ เพราะไม่ต้องลงทุนเริ่มต้นใดๆ ก็สามารถรับชำระเงินออนไลน์ได้ทุกที่ทุกเวลา จากลูกค้าได้ทั่วโลก  <br><br>Stripe บน FlowAccount<br> รองรับ: VISA, Master และ PromptPay<br><br>Omise บน FlowAccount<br>รองรับ: VISA, Master และ JCB'
    FAQ3.link = ''
    FAQ3.head_class = ''
    FAQ3.detail_class = 'homepage-faq2'

    const FAQ4 = new Faq()
    FAQ4.heading =  'ระยะเวลาที่จะได้รับการยืนยันตัวตนจาก Stripe และ Omise เมื่อสมัครผ่าน FlowAccount' 
    FAQ4.shortDescription = 'Stripe<br>มี Automated KYC คือระบบ AI ที่ใช้ตรวจสอบการยืนยันตัวตนจากเอกสารของผู้สมัครแบบอัตโนมัติ  มีระบบการเรียนรู้จากกรณีตัวอย่างหลายล้านรายการ สามารถรู้ผลได้เลยภายใน 72 ชั่วโมงเมื่อส่งเอกสารประกอบครบถ้วน<br> <br>Omise <br> หากสมัครด้วยตัวเอง โดยไม่ได้กดสมัครบน FlowAccount จะใช้ระยะเวลาตรวจสอบเอกสารอยู่ที่ 7 - 14 วันทำการหลังจากส่งเอกสารครบถ้วน<br><br>รายละเอียดเพิ่มเติม<br>Stripe: <a href="https://stripe.com/th/payments"   rel="nofollow noopener" target="_blank">https://stripe.com/th/payments</a><br>Omise: <a href=" https://www.omise.co/th/thailand"   rel="nofollow noopener" target="_blank"> https://www.omise.co/th/thailand</a> '
    FAQ4.link = ''
    FAQ4.head_class = ''
    FAQ4.detail_class = 'homepage-faq2'

    const FAQ5 = new Faq()
    FAQ5.heading =  'ระยะเวลาที่จะได้รับเงินจากลูกค้า หากเชื่อมต่อกับ Stripe หรือ Omise ' 
    FAQ5.shortDescription = 'Stripe<br>เมื่อได้รับเงินจากลูกค้า ยอดเงินจะปรากฎในระบบไม่เกิน 7 วัน<br><br>Omise<br>เมื่อได้รับเงินเข้ามายอดเงินจะปรากฏในระบบทันที แต่จะถูกเก็บรักษาเป็นเวลา 3-7 วัน โดยจะถูกรวมไว้ที่ ‘ยอดเงินที่อยู่ระหว่างการตรวจสอบ’'
    FAQ5.link = ''
    FAQ5.head_class = ''
    FAQ5.detail_class = 'homepage-faq2'
   
    const FAQ6 = new Faq()
    FAQ6.heading =  'ความปลอดภัยของการเชื่อมต่อ Stripe และ Omise' 
    FAQ6.shortDescription = 'Stripe<br>Stripe Radar : ระบบตรวจจับและบล็อกการฉ้อโกงด้วยแมชชีนเลิร์นนิงที่ได้รับการฝึกสอนข้อมูลจากบริษัทหลายล้านแห่งทั่วโลก พิเศษสำหรับลูกค้าที่สมัครผ่าน FlowAccount ซึ่งสามารถประเมินความเสี่ยงและบล็อกการชำระเงินที่ระบบพบว่ามีความเสี่ยงสูงให้เลยอัตโนมัติ อ่านข้อมูล Stripe Radar เพิ่มเติม: <a href="https://stripe.com/th/radar" rel="nofollow" target="_blank" >https://stripe.com/th/radar</a> <br> <br>Omise <br> Fraud Detection:  ระบบป้องกันการฉ้อโกงแบบครบวงจร ตั้งแต่ IP Geolocation ที่เข้าถึงเวลาและสถานที่ทำธุรกรรมใช้-จ่ายเงินอย่างแม่นยำ, ระบบ Tokenization ที่จะสลับรหัสบัตรให้อัตโนมัติ เพื่อรักษาความปลอดภัยในการสุ่มโจรกรรมจากตัวเลข โดยแต่ละรหัสจะสามารถทำธุรกรรมใช้จ่ายได้เพียงหนึ่งครั้งต่อหนึ่งร้านเท่านั้น และอื่นๆ อีกมากมายตามข้อมูลเพิ่มเติม: <a href="https://www.omise.co/th/fraud-protection" rel="nofollow" target="_blank">https://www.omise.co/th/fraud-protection</a> '
    FAQ6.link = ''
    FAQ6.head_class = ''
    FAQ6.detail_class = 'homepage-faq2'


    return [FAQ1, FAQ2, FAQ3, FAQ4, FAQ5, FAQ6]
  }


  private temp() {
    const FAQ1 = new Faq()
    FAQ1.heading = ''
    FAQ1.shortDescription = ''
    FAQ1.link = ''
    FAQ1.head_class = ''
    FAQ1.detail_class = ''

    const FAQ2 = new Faq()
    FAQ2.heading = ''
    FAQ2.shortDescription = ''
    FAQ2.link = ''
    FAQ2.head_class = ''
    FAQ2.detail_class = ''

    const FAQ3 = new Faq()
    FAQ3.heading = ''
    FAQ3.shortDescription = ''
    FAQ3.link = ''
    FAQ3.head_class = ''
    FAQ3.detail_class = ''

    const FAQ4 = new Faq()
    FAQ4.heading = ''
    FAQ4.shortDescription = ''
    FAQ4.link = ''
    FAQ4.head_class = ''
    FAQ4.detail_class = ''

    const FAQ5 = new Faq()
    FAQ5.heading = ''
    FAQ5.shortDescription = ''
    FAQ5.link = ''
    FAQ5.head_class = ''
    FAQ5.detail_class = ''

    const FAQ6 = new Faq()
    FAQ6.heading = ''
    FAQ6.shortDescription = ''
    FAQ6.link = ''
    FAQ6.head_class = ''
    FAQ6.detail_class = ''

    return [FAQ1, FAQ2, FAQ3, FAQ4, FAQ5, FAQ6]
  }
}
